import { render, staticRenderFns } from "./lock-expand.vue?vue&type=template&id=5173ba94&scoped=true&"
import script from "./lock-expand.vue?vue&type=script&lang=js&"
export * from "./lock-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5173ba94",
  null
  
)

export default component.exports